// Capa PRESENTED (Fase 5). Consume del backend el documento de perfil de pantalla ya fusionado
// (system → vertical → plataforma → cuenta) y FILTRADO por entitlement. Los perfiles nunca
// conceden acceso: solo ordenan/presentan lo que el permiso ya permite. El consumidor SIEMPRE
// debe tener defaults propios y tratar el documento como una sugerencia (fallback-safe).
//
// Cachea por screenId (dentro de la sesión) y se invalida cuando cambian los entitlements
// (el mismo evento AppEventBus que dispara el refresh sin logout), porque el filtrado por
// columna depende de los módulos concedidos.
import httpRequest from './httpRequest';
import AppEventBus from '@/AppEventBus';

const cache = new Map(); // screenId -> { document, screenProfilesVersion }

export async function getScreenProfile(screenId, platform = 'web', { force = false } = {}) {
    if (!screenId) return { document: {}, screenProfilesVersion: null };
    if (!force && cache.has(screenId)) return cache.get(screenId);
    const res = await httpRequest.getScreenProfile(screenId, platform);
    if (res && res.status === 200 && res.data) {
        const entry = { document: res.data.document || {}, screenProfilesVersion: res.data.screenProfilesVersion };
        cache.set(screenId, entry);
        return entry;
    }
    // Falla (502 / red): devolvemos lo cacheado o un documento vacío. El consumidor usa sus defaults.
    return cache.get(screenId) || { document: {}, screenProfilesVersion: null };
}

export function clearScreenProfileCache() {
    cache.clear();
}

// Al cambiar los entitlements (plan/override/rol/asiento) el filtrado por columna puede cambiar:
// vaciamos el cache para que el próximo getScreenProfile traiga el documento actualizado.
AppEventBus.on('entitlements_changed', clearScreenProfileCache);

// Un admin editó un ScreenProfile aplicable a este negocio (Fase 6): el backend empuja
// `screen_profiles_changed` y App.vue reemite este evento. Invalidamos el cache para traer
// el perfil nuevo en el próximo getScreenProfile (sin tocar sesión ni menú).
AppEventBus.on('screen_profiles_changed', clearScreenProfileCache);

export default { getScreenProfile, clearScreenProfileCache };
